import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BackButton = () => {
  const nagivate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex items-start">
      <button
        className="mt-4 text-black transition-all hover:text-majky-500 dark:text-white dark:hover:text-majky-500"
        onClick={() => {
          nagivate("/");
        }}
      >
        {"↩ " + t("Home")}
      </button>
    </div>
  );
};

export default BackButton;
